module.exports = __webpack_public_path__ + "static/apple-icon-114x114-2012e33c0068c9b2360b2e9c9b44e842.png";